import { Schema as S } from "effect";
export const Schema = S.Union(S.Literal("active"), S.Literal("cancelled"), S.Literal("expired"), S.Literal("grace_period"), S.Literal("in_retry"), S.Literal("paused"), S.Literal("billing_issue")).pipe(S.brand("@open-revenue/schema/subscriptions/SubscriptionStatus"));
export const Type = Schema.Type;
export const Active = "active";
export const Cancelled = "cancelled";
export const Expired = "expired";
export const GracePeriod = "grace_period";
export const InRetry = "in_retry";
export const Paused = "paused";
export const BillingIssue = "billing_issue";
export const makeUnsafe = (status)=>status;
export const make = (status)=>S.decodeUnknown(Schema)(status);
